import { render } from "./BlogsListing.vue?vue&type=template&id=65f4abf5"
import script from "./BlogsListing.vue?vue&type=script&lang=js"
export * from "./BlogsListing.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__